import { useEffect, useRef } from 'react';
import { UseClickOutsideParams } from './types';

export const useOutsideClick = <Element extends HTMLElement>({ callback }: UseClickOutsideParams) => {
    const parentRef = useRef<Element>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent | TouchEvent) => {
            const target = event.target as Node;
            const isParentContainsTarget = Boolean(parentRef?.current?.contains(target));
            if (isParentContainsTarget) {
                return;
            }
            callback();
        };

        document.addEventListener('mouseup', handleClickOutside);
        document.addEventListener('touchend', handleClickOutside);

        return () => {
            document.removeEventListener('mouseup', handleClickOutside);
            document.removeEventListener('touchend', handleClickOutside);
        };
    }, [callback]);

    return parentRef;
};
